const SceneKeys = {
  Preloader: 'preloader',
  Main: 'main',
  GameOver: 'game-over',
};

export default SceneKeys;
